/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemAgreementFull,
  ItemAgreementFullOptional,
  ItemAgreementFullMetaI,
  ItemAgreementFullTrackedI,
} from "./item-agreement-full";
import {
  ItemAgreementFullTracked,
  ItemAgreementFullMeta,
} from "./item-agreement-full";

/**
 *
 * @export
 * @interface ItemAgreementDTO
 */
export interface ItemAgreementDTOOptional extends ItemAgreementFullOptional {
  /**
   *
   * @type {number}
   * @memberof ItemAgreementDTO
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof ItemAgreementDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ItemAgreementDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {AgreementRef}
   * @memberof ItemAgreementDTO
   */
  agreementId?: AgreementRefOptional;
}

export interface ItemAgreementDTO
  extends ItemAgreementDTOOptional, ItemAgreementFull {
  /**
   *
   * @type {number}
   * @memberof ItemAgreementDTO
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof ItemAgreementDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ItemAgreementDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {AgreementRef}
   * @memberof ItemAgreementDTO
   */
  agreementId: AgreementRef;
}

export interface ItemAgreementDTOTrackedI extends ItemAgreementFullOptional {
  /**
   *
   * @type {number}
   * @memberof ItemAgreementDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ItemAgreementDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ItemAgreementDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {AgreementRef}
   * @memberof ItemAgreementDTO
   */
  agreementId?: AgreementRefTrackedI;
  agreementIdIsSet: boolean;
}

transformDatesMap.set("ItemAgreementDTO", function (model: ItemAgreementDTO) {
  const transformDatesagreementId = transformDatesMap.get("AgreementRef");
  if (transformDatesagreementId && model.agreementId) {
    transformDatesagreementId(model.agreementId);
  }
});

export type ItemAgreementDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  agreementId: PropertyMeta<AgreementRefMetaI>;
}>;

export var ItemAgreementDTOMeta: ItemAgreementDTOMetaI =
  {} as ItemAgreementDTOMetaI;
ItemAgreementDTOMeta = typeMeta("ItemAgreementDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  agreementId: propertyMeta(
    "agreementId",
    false,
    true,
    false,
    AgreementRefMeta,
  ),
});

const metaI = ItemAgreementDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ItemAgreementFullMeta]);
  metaI.assignId.inheritedFrom = ItemAgreementFullMeta.assignId;
  metaI.isDeleted.inheritedFrom = ItemAgreementFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = ItemAgreementFullMeta.isNew;
  metaI.agreementId.inheritedFrom = ItemAgreementFullMeta.agreementId;
});

export class ItemAgreementDTOTracked
  extends ItemAgreementFullTracked
  implements ItemAgreementDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  agreementId__I?: AgreementRefTracked = undefined;
  agreementIdIsSet: boolean = false;
  set agreementId(v: undefined | AgreementRefTracked) {
    if (v !== undefined) {
      this.agreementId__I = v;
      this.agreementIdIsSet = true;
    } else {
      this.agreementId__I = v || undefined;
      this.agreementIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get agreementId() {
    return this.agreementId__I;
  }
  constructor(config?: ItemAgreementDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.agreementId?.setIds();
  }
  assignFrom(
    config: ItemAgreementDTOOptional,
    options?: AssignOptions,
  ): ItemAgreementDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.agreementId &&
      this.agreementIdApplyFilter(optionsRequired.filter)
    ) {
      this.agreementId = new AgreementRefTracked(config.agreementId, options);
      if (optionsRequired.unassign) this.agreementIdIsSet = false;
      else this.agreementIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ItemAgreementDTOTrackedI {
    const cloned = {} as ItemAgreementDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.agreementIdIsSetDeep() &&
      this.agreementIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementIdIsSet = true;
      cloned.agreementId = this.agreementId?.removeUnset(filter);
    } else {
      //cloned.agreementIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ItemAgreementDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.agreementIdApplyFilter(filter)) this.agreementIdIsSet = false;
    this.agreementId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemAgreementDTOMeta.assignId,
      ItemAgreementDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemAgreementDTOMeta.isDeleted,
      ItemAgreementDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemAgreementDTOMeta.isNew,
      ItemAgreementDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  agreementIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemAgreementDTOMeta.agreementId,
      ItemAgreementDTOMeta,
      this.agreementId,
      this,
    );
  }
  agreementIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementIdIsSet && this.agreementIdApplyFilter(filter))
      return true;
    return this.agreementId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.agreementIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
